module.exports = __webpack_public_path__ + "img/turkcell-foursquare-launch-01.e93bdfc2.jpg";